(ns ycweb.app.website.myaccount.reviews.edit
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.app.website.myaccount.reviews.common :as awmr.common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as input-forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

;; Components ===================================================================================================================

(rum/defcs reviews-form < rum/reactive (cmn/local nil ::node-atom) [local-atom app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        review-atom (rum/cursor-in action-atom [:review])
        node-atom (::node-atom local-atom)

        {:item-line/keys [product variation] :as review-item} (rum/react review-atom)
        {:product/keys [link name-ex-brand brand-name]} product]
    [:div.dashboard__grid-row.flex-grid-group
     [:div {:class (u/bem :flex-grid-block [:ml-1-4 :ml-order-02])}
      [:div.flex-grid-content
       [:div.flex-grid-row
        [:div.flex-grid-block.flex-grid-block--full
         [:div.card.product-card.flex-grid-content
          [:div.card__hero
           [:a.u-block-link {:href link}
            (web-common/lazy-image app-atom
              (:doc/public-id (:ent/image variation))
              {:class ["card__image"]}
              {:w 233 :h 233 :q "auto" :c "lpad" :f "auto" :e "sharpen:40"})]]
          [:a.u-block-link {:href "#"}
           [:div.card__content-wrapper
            [:div.card__content
             [:header.card__header
              [:h2.product-card__title
               [:span.product-card__brand brand-name]
               [:span.product-card__name name-ex-brand]]]]]]]]]]]
     [:div {:class (u/bem :flex-grid-block [:ml-3-4])}
      [:div.flex-grid-content
       [:form.form.u-max-width-480
        {:ref (fn [node] (reset! node-atom node))}
        [:div.form-field
         (input-forms/input "Review title:" "e.g. This product is amazing!" (rum/cursor review-atom :ent/display-name)
           {:id :review-title
            :name :conf_title
            :required? true
            :hint "Note: This will appear at the top of your review, e.g. \"This product is amazing!\""})]
        (into
          [:div.form-section
           [:p.form-question.form-question--set
            "How many stars would you give this item?"]]
          (map-indexed (partial awmr.common/star-selector (rum/cursor review-atom :review/stars)) awmr.common/star-desc))
        [:div.form-section
         [:p.form-question.form-question--set
          "Would you recommend this product to a friend?"]
         [:div.form-field
          (input-forms/radio "Yes" 1 (rum/cursor review-atom :review/recommend))]
         [:div.form-field
          (input-forms/radio "No" 0 (rum/cursor review-atom :review/recommend))]]
        [:div.form-field
         (input-forms/textarea "Write your review below:"
           (rum/cursor review-atom :review/review)
           {:rows "10"})]
        [:div.form-field
         [:p {:class (u/bem :yc-paragraph [:small :flush])}
          "If your review refers to a problem that could be specific to the item you received, not the product in general, please "
          [:a.text-link {:href "/help.htm"} "contact customer support"]
          " so we can work on resolving it with you directly as soon as possible."]]
        [:div.form-control.u-max-width-480
         (buttons/button-web "Submit your review"
           {:on-click
            (input-forms/form-validate node-atom #(grid/dispatch-action app-atom :web.myaccount.review/edit {:review review-item}))
            :type :button
            :style :primary
            :size :default})]
        [:div.form-field
         [:p {:class (u/bem :yc-paragraph [:small :flush])}
          "By submitting this review, you agree to our "
          [:a.text-link.js-mfp-open-url
           {:href "/help.htm?action=article&id=157"
            :target_url "/help.htm?action=article&id=157&overrideincludes=blank"
            :data-title "Review Terms & Conditions"
            :data-content-wrapper-class "yc-simple-text"}
           "Terms & Conditions"] "."]]]]]]))

(rum/defc reviews-edit < rum/reactive [app-atom]
  (let [state (rum/react (cmn/action-cursor app-atom))]
    [:div.dashboard
     (headings/heading "Edit your product review" {:type :h2 :size :medium})
     (reviews-form app-atom)
     (toaster/loading-overlay app-atom :web.myaccount/reviewsedit)]))

;; Routing ===================================================================================================================

(defmethod grid/action :web.myaccount.review/edit [app-atom config _]
  (toaster/open-toast app-atom :processing "Saving" {:closetime 10000})
  (comms/ajax-post :web.myaccount/reviewsaveedit
    {:review (:review config)}))

(defmethod comms/receive :web.myaccount/reviewsaveedit [app-atom e]
  (if (:success e)
    (do
      (toaster/open-toast app-atom :success "Saved" {:closetime 2000})
      (urlstate/redirect app-atom "myaccount" "reviewsthankyou" {:uuid (:uuid e)}))
    (toaster/open-toast app-atom :error (:msg e) {:closetime 5000})))

(defmethod flow/render-screen :web.myaccount/reviewsedit [app-atom _]
  (awm.common/screen-wrapper app-atom
    (reviews-edit app-atom)))

(defmethod t/transition-open :web.myaccount/reviewsedit [app-atom _ params]
  (toaster/open-overlay app-atom :web.myaccount/reviewsedit)
  (comms/ajax-post :web.myaccount/reviewsedit (select-keys params [:uuid])))

(defmethod comms/receive :web.myaccount/reviewsedit [app-atom e]
  (swap! (cmn/action-cursor app-atom) assoc
    :review (:review e))
  (toaster/close-overlay app-atom :web.myaccount/reviewsedit))

